import { useQuery } from '@tanstack/react-query';
import { api } from '@shared/api/client';
import { SUBSCRIPTION } from '@shared/api/endpoints';
import { useBitrix24 } from '@shared/hooks/useBitrix24';
import type { SubscriptionResponse } from '@tailorcast/shared-types';

export function useSubscription() {
  const { isBitrix24 } = useBitrix24();
  return useQuery({
    queryKey: ['subscription'],
    queryFn: () => api.get<SubscriptionResponse>(SUBSCRIPTION.STATUS),
    enabled: isBitrix24,
    staleTime: 5 * 60 * 1000,
  });
}
